import { render, staticRenderFns } from "./Warsztaty.vue?vue&type=template&id=09de4871&"
import script from "./Warsztaty.vue?vue&type=script&lang=js&"
export * from "./Warsztaty.vue?vue&type=script&lang=js&"
import style0 from "./Warsztaty.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Warsztaty.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VExpansionPanel } from 'vuetify/lib'
import { VExpansionPanelContent } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VContainer,
  VExpansionPanel,
  VExpansionPanelContent,
  VFlex,
  VLayout,
})
